export const fetchTemplateList = ({
  page = 1,
  perPage,
  search = '',
  jurisdiction = 'mx',
  isDynamic,
  populate,
  pluginType,
  searchExact
}) => {
  let queryString = `?page=${page}&perPage=${perPage}&search=${search}&jurisdiction=${jurisdiction}`
  if (populate) {
    queryString += `&populate=${populate}`;
  }
  if (isDynamic) {
    queryString += `&isDynamic=${isDynamic}`;
  }
  if (searchExact) {
    queryString += `&searchExacct=${searchExact}`;
  }
  if (pluginType) {
    queryString += `&pluginType=${pluginType}`;
  }
  return ({
    method: 'GET',
    endpoint: `/templates${queryString}`,
  })
};

export const fetchRequestedTemplateList = ({
  page = 1,
  perPage = 5,
  search = '',
  status,
  categories
}) => {
  let queryString = `?page=${page}&perPage=${perPage}&search=${search}`

  if (status) queryString += `&status=${status}`
  if (categories) queryString += `&categories=${categories}`

  return ({
    method: 'GET',
    endpoint: `/requested-templates${queryString}`,
  })
};

export const fetchTemplate = (templateId) => ({
  method: 'GET',
  endpoint: `/templates/${templateId}`,
});

export const fetchPublicTemplate = (templateId, hasAccount = true) => ({
  method: 'GET',
  prefix: hasAccount ? '' : ' ',
  endpoint: `/public-templates/${templateId}`,
});

export const fetchLawyerList = ({
  page = 1,
  perPage = 10,
  search = ''
}, hasAccount = true) => ({
  method: 'GET',
  prefix: hasAccount ? '' : ' ',
  endpoint: `/lawyers?page=${page}&perPage=${perPage}&search=${search}`,
});

export const bookmarkPublicTemplate = ({publicTemplateId}) => ({
  method: 'POST',
  prefix: ' ',
  endpoint: `/public-templates/${publicTemplateId}/bookmark`,
});

export const unbookmarkPublicTemplate = ({publicTemplateId}) => ({
  method: 'POST',
  prefix: ' ',
  endpoint: `/public-templates/${publicTemplateId}/unbookmark`,
});

export const fetchPublicTemplateList = ({
  type = null,
  currency = 'mxn',
  page = 1,
  search = '',
  perPage = 0,
  category = '',
  jurisdiction = 'mx',
  sortBy = 'type',
  isPlaylist = 'false',
  searchExact,
  onlyTemplates = 'false',
  onlyMyTemplates = 'false',
  isBookmark = 'false',
  onlyExternal = 'false',
  user
}) => {
  let queryString = `type=${type}&currency=${currency}&jurisdiction=${jurisdiction}&perPage=${perPage}&page=${page}&search=${search}&category=${category}&searchExact=${searchExact}&onlyTemplates=${onlyTemplates}&sortBy=${sortBy}&isPlaylist=${isPlaylist}&isBookmark=${isBookmark}&onlyMyTemplates=${onlyMyTemplates}&onlyExternal=${onlyExternal}`
  if (user) {
    queryString += `&user=${user}`
  }

  return {
    method: 'GET',
    endpoint: `/public-templates?${queryString}`,
  }
};

export const fetchBookmarkPublicTemplates = () => ({
  method: 'GET',
  endpoint: `/public-templates/bookmarks`,
});

export const fetchFeaturedPublicTemplate = () => ({
  method: 'GET',
  endpoint: `/public-templates/featured`,
  prefix: ' ',
});

export const requestTemplate = (values) => ({
  method: 'POST',
  endpoint: `/templates/request`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})
export const deleteRequestTemplate = (values) => ({
  method: 'DELETE',
  endpoint: `/requested-templates/${values.requestTemplateId}`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const grabPublicTemplate = ({publicTemplateId, isPremium}) => ({
  method: 'POST',
  endpoint: `/public-templates/${publicTemplateId}${isPremium ? '/premium' : ''}/grab`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const viewPublicTemplate = ({publicTemplateId}) => ({
  method: 'POST',
  endpoint: `/public-templates/${publicTemplateId}/view`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const updateTemplate = ({templateId, ...values}) => ({
  method: 'PUT',
  endpoint: `/templates/${templateId}`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const updatePublicTemplate = ({templateId, ...values}) => ({
  method: 'PUT',
  endpoint: `/public-templates/${templateId}`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})
export const removePublicTemplate = ({templateId, ...values}) => ({
  method: 'DELETE',
  endpoint: `/public-templates/${templateId}`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const deleteTemplate = ({templateId}) => ({
  method: 'DELETE',
  endpoint: `/templates/${templateId}`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const createTemplate = (values) => ({
  method: 'POST',
  endpoint: `/templates`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const fetchTemplatesSaleHistoryList = ({
  page = 1,
  search = '',
  perPage = 1,
  isRedeemed = false,
  sortBy = 'createdAt',
}) => ({
  method: 'GET',
  endpoint: `/sales-history?perPage=${perPage}&page=${page}&search=${search}&sortBy=${sortBy}&isRedeemed=${isRedeemed}`,
});

export const fetchTemplatesSaleHistoryStats = () => ({
  method: 'GET',
  endpoint: `/sales-history/stats`,
});